module.exports = __webpack_public_path__ + "img/microsoft-art-of-work-logo.76dace3f.png";